import { render, staticRenderFns } from "./IconImport.vue?vue&type=template&id=67fbee59&scoped=true&"
var script = {}
import style0 from "./IconImport.vue?vue&type=style&index=0&id=67fbee59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fbee59",
  null
  
)

export default component.exports